import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { FaStar } from 'react-icons/fa6';
import 'swiper/css';
import 'swiper/css/pagination';

const reviews = [
  {
    title: 'G.T.',
    stars: 5,
    text: 'Mi sono rivolto ad Mcare a seguito di una grave lussazione di spalla causata in moto. Mi hanno fatto sentire fin da subito a mio agio, Paolo, Luca e tutti i ragazzi del team. Dopo due/tre mesi sono tornato in forma al 100% nonostante il recupero sembrava più difficoltoso. Sono stato seguito in maniera super accurata e mi ritengo molto fortunato di aver svolto la riabilitazione con loro.'
  },
  {
    title: 'A.G.',
    stars: 5,
    text: 'In terapia da 6 mesi, pre e post intervento legamento crociato. Una famiglia che ti accoglie e ti segue in tutte le fasi con grande professionalità, umanità e disponibilità. Grazie!'
  },
  {
    title: 'E.L.',
    stars: 5,
    text: 'Centro di riabilitazione nuovo, personale molto accogliente! sono stato seguito dalla fisioterapista Anna che ha fatto un ottimo lavoro e mi ha dato tanti utili consigli. Assolutamente consigliato!'
  },
  {
    title: 'D.Q.',
    stars: 5,
    text: 'Mi hanno consigliato questo centro più per la comodità data la vicinanza all’inizio, ma sono felice di aver scoperto che sono specializzati nello sport. Fisioterapista competente e disponibile. La clinica è nuovissima e ben attrezzata, molto comodo anche l’ampio parcheggio e il fatto che sia proprio all’uscita dell’autostrada Verona sud. Consigliatissimo'
  },
  {
    title: 'R.P.',
    stars: 5,
    text: 'Problemi alla colonna vertebrale che altrove non sono riuscito a curare in maniera efficace. Qui grazie alla professionalità di Luca e Paolo, sto decisamente meglio dopo poche sedute. Bravi e grazie!!'
  },
  {
    title: 'P.P.',
    stars: 5,
    text: 'Professionalità, disponibilità e accoglienza hanno risolto il mio problema su una cicatrizzazione fastidiosa. Voto 10'
  },
  {
    title: 'G.P.',
    stars: 5,
    text: "Centro d'eccellenza sotto tutti i punti di vista. Dalla gentilezza delle segretarie alla competenza e cura dei fisioterapisti. Ti senti seguito passo dopo passo con grande professionalità."
  },
  {
    title: 'G.L.',
    stars: 5,
    text: "Professionisti aggiornati, preparati e disponibili. Fisioterapia all'avanguardia."
  },
];

function ReviewCard({ title, stars, text }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="h-full text-center flex flex-col justify-center border border-black/10 rounded-lg shadow-md p-6 bg-black/80 text-white">
      <p className="font-semibold text-xl text-white">{title}</p>

      <div className="flex gap-1 my-3 justify-center">
        {Array.from({ length: stars }).map((_, i) => (
          <FaStar key={i} className="w-5 h-5 text-mcare" />
        ))}
      </div>

      <p className={`text-white ${expanded ? '' : 'truncate'}`}>
        {text}
      </p>

      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="mt-2 text-sm text-mcare underline self-center hover:text-white">
        {expanded ? 'Mostra di meno' : 'Mostra di più'}
      </button>
    </div>
  );
}

function Reviews() {
  return (
    <div className="w-full z-10">
      <h2 className="text-3xl font-semibold text-center mb-20 mx-5 sm:mx-0 text-white panoragraf-light" data-aos="fade-in">
        Le recensioni dei nostri pazienti
      </h2>

      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        spaceBetween={24}
        grabCursor={true}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1280: { slidesPerView: 3 },
        }}
        className="lg:w-[80%] w-[90%] mx-auto pb-12"
        data-aos="fade-in"
        data-aos-delay="200">
        {reviews.map((review, index) => (
          <SwiperSlide key={index} className="h-auto py-1 ">
            <ReviewCard {...review}  />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Reviews;
